(function () {
  'use strict';

  const popup = document.getElementById('grusskarten-popup');
  if (!popup) return;

  // Übersetzte Strings aus Liquid via data-Attribute (locales/{en,de}.json)
  const i18n = {
    adding: popup.dataset.i18nAdding || 'Adding…',
    errorPrefix: popup.dataset.i18nErrorPrefix || 'The card could not be added:',
    unknownError: popup.dataset.i18nUnknownError || 'Unknown error',
    propertyName: popup.dataset.i18nPropertyName || 'Gift message',
    addButton: popup.dataset.i18nAddButton || 'Add card & checkout',
    addButtonOne: popup.dataset.i18nAddButtonOne || 'Add {{ count }} card & checkout',
    addButtonOther: popup.dataset.i18nAddButtonOther || 'Add {{ count }} cards & checkout'
  };

  const checkoutSelectors = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]'
  ].join(',');

  let popupAnswered = false;
  let pendingHref = null;

  document.addEventListener(
    'click',
    function (e) {
      if (popupAnswered) return;
      if (window.location.pathname.indexOf('/checkout') === 0) return;

      const target = e.target.closest(checkoutSelectors);
      if (!target) return;

      e.preventDefault();
      e.stopPropagation();

      pendingHref = target.tagName === 'A' ? target.getAttribute('href') : null;

      openPopup();
    },
    true
  );

  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('grusskarten-popup-open');
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('grusskarten-popup-open');
  }

  function proceedToCheckout() {
    popupAnswered = true;
    closePopup();

    if (pendingHref) {
      window.location.href = pendingHref;
      return;
    }

    // Frische Form bauen und POST /cart mit checkout=1 absetzen — exakt das,
    // was der native Button-Submit tut. Unabhängig von der re-renderten
    // Drawer-Form und funktioniert auf Dev-Server + Live gleichermaßen.
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/cart';
    form.style.display = 'none';

    const checkoutInput = document.createElement('input');
    checkoutInput.type = 'hidden';
    checkoutInput.name = 'checkout';
    checkoutInput.value = '';
    form.appendChild(checkoutInput);

    document.body.appendChild(form);
    form.submit();
  }

  popup.querySelectorAll('[data-grusskarten-close]').forEach(function (el) {
    el.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup();
    }
  });

  // -------------------------------------------------------------------------
  // Multi-Select: Checkbox steuert Textfeld + Button-Status
  // -------------------------------------------------------------------------
  const cardCheckboxes = popup.querySelectorAll('.grusskarten-card__checkbox');
  const addBtn = popup.querySelector('[data-grusskarten-add]');

  function updateAddButton() {
    const checkedCount = popup.querySelectorAll('.grusskarten-card__checkbox:checked').length;
    if (checkedCount === 0) {
      addBtn.disabled = true;
      addBtn.textContent = i18n.addButton;
      return;
    }
    addBtn.disabled = false;
    const template = checkedCount === 1 ? i18n.addButtonOne : i18n.addButtonOther;
    addBtn.textContent = template.replace('{{ count }}', String(checkedCount));
  }

  cardCheckboxes.forEach(function (cb) {
    cb.addEventListener('change', function () {
      const variantId = cb.value;
      const msgItem = popup.querySelector('[data-msg-for="' + variantId + '"]');
      if (msgItem) {
        msgItem.hidden = !cb.checked;
        if (cb.checked) {
          const ta = msgItem.querySelector('textarea');
          if (ta) ta.focus();
        }
      }
      updateAddButton();
    });
  });

  // Character-Counter pro Textarea
  popup.querySelectorAll('.grusskarten-message-item textarea').forEach(function (ta) {
    const variantId = ta.dataset.variantId;
    const counter = popup.querySelector('[data-counter-for="' + variantId + '"]');
    if (!counter) return;
    ta.addEventListener('input', function () {
      counter.textContent = String(ta.value.length);
    });
  });

  // Skip-Button
  const skipBtn = popup.querySelector('[data-grusskarten-skip]');
  if (skipBtn) {
    skipBtn.addEventListener('click', proceedToCheckout);
  }

  // -------------------------------------------------------------------------
  // Submit: alle ausgewählten Karten mit individuellen Texten hinzufügen
  // -------------------------------------------------------------------------
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      const checked = popup.querySelectorAll('.grusskarten-card__checkbox:checked');
      if (checked.length === 0) return;

      const items = [];
      checked.forEach(function (cb) {
        const variantId = parseInt(cb.value, 10);
        const ta = popup.querySelector('textarea[data-variant-id="' + cb.value + '"]');
        const message = ta ? (ta.value || '').trim() : '';
        const properties = {};
        if (message) properties[i18n.propertyName] = message;
        items.push({ id: variantId, quantity: 1, properties: properties });
      });

      addBtn.disabled = true;
      addBtn.textContent = i18n.adding;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(data.description || i18n.unknownError);
            });
          }
          return res.json();
        })
        .then(function () {
          proceedToCheckout();
        })
        .catch(function (err) {
          console.error('[Grußkarten-Popup]', err);
          addBtn.disabled = false;
          updateAddButton();
          alert(
            i18n.errorPrefix +
              '\n' +
              (err && err.message ? err.message : i18n.unknownError)
          );
        });
    });
  }
})();
